import { Outlet } from "react-router-dom";

const Permisos = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Permisos;
